import React, { Suspense, lazy, useEffect } from "react";
import ReactGA from "react-ga";
import styled from "styled-components";
import { Route, Switch, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { IMAGE_SOURCE } from "../constants/imgSource";

const MainContent = styled.div`
  min-height: 600px;
`;

const imagePromise = (resource) => {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = resource.src;
    image.alt = resource.alt;
    image.onload = () => {
      resolve();
    };
  });
};

const Home = lazy(() =>
  Promise.all(
    IMAGE_SOURCE.home.map((resource) => imagePromise(resource))
  ).then(() => import("./home"))
);

function Routes({ lang }) {
  useEffect(() => {
    ReactGA.initialize("UA-166890180-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const path = useLocation().pathname;
  useEffect(() => {
    ReactGA.pageview(path);
  }, [path]);

  return (
    <Suspense fallback={<Loader />}>
      <MainContent lang={lang}>
        <Switch>
          <Route exact path="/mr_market" component={Home} />
        </Switch>
      </MainContent>
      <Footer />
    </Suspense>
  );
}

export default Routes;
